import React from 'react';

interface IProps {
    className?: string;
}

const Spinner = ({ className }: IProps) => {
    return (<i id="Spinner" className={`bx bx-loader bx-spin ${className ?? ''}`}></i>);
};

export default Spinner;